import { render } from "./AppSidebar.vue?vue&type=template&id=5fb51c2b"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"
script.render = render

export default script